import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface TopbarProps {
  onNewDub: () => void
  onOpenNotifications?: () => void
  unreadCount?: number
  onToggleMobileNav?: () => void
  onToggleMobileJobs?: () => void
  activeJobCount?: number
}

const ROUTE_TITLES: Record<string, string> = {
  '/dashboard': 'nav.watch',
  '/extension': 'nav.extension',
  '/usage':     'nav.usage',
}

export default function Topbar({ onNewDub, onOpenNotifications, unreadCount = 0, onToggleMobileNav, onToggleMobileJobs, activeJobCount = 0 }: TopbarProps) {
  const { t } = useTranslation()
  const location = useLocation()

  const titleKey = ROUTE_TITLES[location.pathname] ?? 'nav.watch'

  return (
    <div className="app-topbar">
      <div className="topbar-left">
        {onToggleMobileNav && (
          <button className="mobile-hamburger" onClick={onToggleMobileNav} aria-label="Menu">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        )}
        <span className="topbar-title">{t(titleKey)}</span>
      </div>
      <div className="topbar-right">
        {onToggleMobileJobs && (
          <button className="mobile-queue-btn" onClick={onToggleMobileJobs} aria-label="Dub Queue" style={{ position: 'relative' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="3" width="7" height="7" rx="1" />
              <rect x="3" y="14" width="7" height="7" rx="1" />
              <rect x="14" y="14" width="7" height="7" rx="1" />
            </svg>
            {activeJobCount > 0 && (
              <span className="mobile-queue-badge">{activeJobCount > 9 ? '9+' : activeJobCount}</span>
            )}
          </button>
        )}
        {onOpenNotifications && (
          <button className="sidebar-theme" onClick={onOpenNotifications} aria-label="Notifications" style={{ position: 'relative' }}>
            <BellIcon />
            {unreadCount > 0 && (
              <span style={{
                position: 'absolute', top: 1, right: 1,
                width: 14, height: 14, borderRadius: '50%',
                background: 'var(--cta)', color: '#fff',
                fontSize: 8, fontWeight: 700,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                lineHeight: 1,
              }}>
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </button>
        )}
        <button className="btn-new-dub" onClick={onNewDub}>
          <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
          {t('shell.newDub')}
        </button>
      </div>
    </div>
  )
}

function BellIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  )
}
